import { createContext } from 'react';
/**
 * Context to pass custom Styled List from custom element to React version
 */

export default /*#__PURE__*/createContext({});
//# sourceMappingURL=CustomListContext.js.map